module.exports = "/_next/static/images/bd9290513d649421556b1c303ad93a69-man-with-cellphone-xs@2x.jpg";